/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { FC, PropsWithChildren } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AlertWrapper } from './Alert';
import { AlertModals } from './AlertModals';
import { ApolloWrapper } from './Apollo';
import { Auth } from './Auth';
import { GoogleRecaptcha } from './GoogleRecaptcha';
import { GoogleRecaptchaV3 } from './GoogleRecaptchaV3';
import { Modals } from './Modals';
import { Pickers } from './PickersProvider';
import { Reminder2FA } from './Reminder2FA';
import { Styles } from './Styles';

const RootProviders: FC<PropsWithChildren> = ({ children }) => (
  <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID ?? ''}>
    <Styles>
      <ApolloWrapper>
        <AlertWrapper>
          <GoogleRecaptchaV3>
            <GoogleRecaptcha>
              <AlertModals>
                <Modals>
                  <Reminder2FA>
                    <Auth>
                      <Pickers>{children}</Pickers>
                    </Auth>
                  </Reminder2FA>
                </Modals>
              </AlertModals>
            </GoogleRecaptcha>
          </GoogleRecaptchaV3>
        </AlertWrapper>
      </ApolloWrapper>
    </Styles>
  </GoogleOAuthProvider>
);

export { RootProviders };
